






import { Vue, Component } from 'vue-property-decorator'
import IconModal from './IconModal.vue'

@Component({
  components: {
    IconModal
  }
})
export default class ErrorModal extends Vue {}
